import { Injectable } from '@angular/core';
import {
  CONSTANTE_INDDIGITALFIRM,
  CONSTANTE_PARAM_FIRMA_DIGITAL,
  CONSTANTE_VERSION_PRESTAMO_REESTRUCTURACIONES,
  CONSTANTE_VERSION_PRIMERA_POLIZAS,
  CONSTANTE_VERSION_SUBROGACION_LEASING,
} from '@app/@core/constants/ine.constants';
import { IneDTOcall } from '@app/requests/model/ine-model';
import {
  AllOperationsDTO,
  CostumerMailDTO,
  GenericPaginationDTO,
  Operation,
  OperationsDTO,
  PaginationRequestAllDTO,
  PaginationResponseDTO,
  VideoSelfingDTO,
} from '@app/requests/model/requests-model';
import { ReplaySubject, Subject } from 'rxjs';
import { isIndexedAccessTypeNode } from 'typescript';

import { RequestPanelService } from './request-panel.service';

@Injectable()
export class RequestPanelStore {
  private pendingRequestsList = new Subject<OperationsDTO>();
  public pendingRequestsList$ = this.pendingRequestsList.asObservable();

  private underStudyRequestsList = new Subject<OperationsDTO>();
  public underStudyRequestsList$ = this.underStudyRequestsList.asObservable();

  private approvedRequestsList = new Subject<OperationsDTO>();
  public approvedRequestsList$ = this.approvedRequestsList.asObservable();

  private paidPendingValidationRequestsList = new Subject<OperationsDTO>();
  public paidPendingValidationRequestsList$ = this.paidPendingValidationRequestsList.asObservable();

  private formalizedPaidAndValidatedRequestsList = new Subject<OperationsDTO>();
  public formalizedPaidAndValidatedRequestsList$ = this.formalizedPaidAndValidatedRequestsList.asObservable();

  private pendingPaymentDueToIncidencesRequestsList = new Subject<OperationsDTO>();
  public pendingPaymentDueToIncidencesRequestsList$ = this.pendingPaymentDueToIncidencesRequestsList.asObservable();

  private signedRequestsList = new Subject<OperationsDTO>();
  public signedRequestsList$ = this.signedRequestsList.asObservable();

  private deniedRequestsList = new Subject<OperationsDTO>();
  public deniedRequestsList$ = this.deniedRequestsList.asObservable();

  private cancelledRequestsList = new Subject<OperationsDTO>();
  public cancelledRequestsList$ = this.cancelledRequestsList.asObservable();

  private conditionedPendingFormalizationList = new Subject<OperationsDTO>();
  public conditionedPendingFormalizationList$ = this.conditionedPendingFormalizationList.asObservable();

  constructor(private requestPanel: RequestPanelService) {}

  public loadOperationPanel(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.requestPanel
        .getOperationsPanel()
        .toPromise()
        .then(
          (data) => {
            if (data) {
              this.pendingRequestsList.next(data.pending);
              this.underStudyRequestsList.next(data.underStudy);
              this.approvedRequestsList.next(data.approved);
              this.paidPendingValidationRequestsList.next(data.paidPendingValidation);
              this.formalizedPaidAndValidatedRequestsList.next(data.formalizedPaidAndValidated);
              this.pendingPaymentDueToIncidencesRequestsList.next(data.pendingPaymentDueToIncidences);
              this.signedRequestsList.next(data.signed);
              this.deniedRequestsList.next(data.denied);
              this.cancelledRequestsList.next(data.cancelled);
              this.conditionedPendingFormalizationList.next(data.conditionedPendingFormalization);
              resolve();
            } else reject();
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public loadOperationsPagination(
    idStatus: string,
    paginationKeys: string[],
    numPage: string,
    paginationType: string
  ): Promise<PaginationResponseDTO> {
    const genericPaginationDTO: GenericPaginationDTO = {
      idStatus: idStatus,
      isMainPanel: 'S',
      paginationKeys: paginationKeys,
      numPage: numPage,
      paginationType: paginationType,
    };
    return new Promise<PaginationResponseDTO>((resolve, reject) => {
      this.requestPanel
        .getOperationsPanelPagination(genericPaginationDTO)
        .toPromise()
        .then(
          (data) => {
            if (data) {
              resolve(data);
            } else reject();
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public loadAllOperations(status: string, isMainPanel: string): Promise<PaginationResponseDTO> {
    let allOperationDTO: AllOperationsDTO = { idStatus: status, isMainPanel: isMainPanel };
    return new Promise<PaginationResponseDTO>((resolve, reject) => {
      this.requestPanel
        .getAllOperations(allOperationDTO)
        .toPromise()
        .then(
          (data) => {
            let stateOperation: PaginationResponseDTO;
            if (data) {
              stateOperation = data;
              resolve(stateOperation);
            } else reject(stateOperation);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public loadAllOperationsPagination(
    idStatus: string,
    paginationKeys: string[],
    numPage: string,
    paginationType: string,
    startYear: string,
    startMonth: string,
    endYear: string,
    endMonth: string
  ): Promise<PaginationResponseDTO> {
    const genericPaginationDTO: PaginationRequestAllDTO = {
      idStatus: idStatus,
      isMainPanel: 'N',
      paginationKeys: paginationKeys,
      numPage: numPage,
      paginationType: paginationType,
      numberRecordsShow: 20,
      startYear: startYear,
      startMonth: startMonth,
      endYear: endYear,
      endMonth: endMonth,
    };
    return new Promise<PaginationResponseDTO>((resolve, reject) => {
      this.requestPanel
        .getAllOperationsPagination(genericPaginationDTO)
        .toPromise()
        .then(
          (data) => {
            if (data) {
              resolve(data);
            } else reject();
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public loadAllOperationsFind(
    idStatus: string,
    startYear: string,
    startMonth: string,
    endYear: string,
    endMonth: string
  ): Promise<PaginationResponseDTO> {
    const genericPaginationDTO: PaginationRequestAllDTO = {
      idStatus: idStatus,
      isMainPanel: 'N',
      paginationKeys: [''],
      numPage: '0',
      paginationType: 'N',
      numberRecordsShow: 160,
      startYear: startYear,
      startMonth: startMonth,
      endYear: endYear,
      endMonth: endMonth,
    };
    return new Promise<PaginationResponseDTO>((resolve, reject) => {
      this.requestPanel
        .getAllOperationsFind(genericPaginationDTO)
        .toPromise()
        .then(
          (data) => {
            if (data) {
              resolve(data);
            } else reject();
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  // servicio para anular operacion

  public cancelResquest(element: Operation): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.requestPanel
        .postCancelRequest(element)
        .toPromise()
        .then(
          (data: boolean) => {
            let stateOperation: PaginationResponseDTO;
            if (data) {
              resolve(true);
            } else reject(stateOperation);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  // servicio reenvio link

  public resendLink(element: Operation, type: string): Promise<boolean> {
    let costumerMail: CostumerMailDTO = {
      email: type === 'email' ? 'OK' : '',
      establishment: element.establishment,
      financialProduct: Number(element.finacialProduct),
      mobile: type === 'mobile' ? 'OK' : '',
      name: '',
      requestNumber: element.numOperation,
      transactionUrl: '',
    };

    return new Promise<boolean>((resolve, reject) => {
      this.requestPanel
        .postResendLink(costumerMail)
        .toPromise()
        .then(
          (data: boolean) => {
            resolve(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  // validaciones INE enviar unos parametros dependiendo del caso

  public validateINE(element: Operation, userInfo: any): any {
    let ineDTO: IneDTOcall;
    let elementAux: any;
    elementAux = element;
    ineDTO = {
      numOperation: element.numOperation,
      financialProduct: element.finacialProduct,
      dateEntry: element.dateEntry,
      operative: element.operative,
      comarca: element.comarca,
      language: element.language,
    };

    if (userInfo.typeUser !== 'M') {
      //Personal y Restructurado son iguales, solo cambian en la version
      if (element.digitalSignatureFlag !== 'S') {
        ineDTO.versPolizas = CONSTANTE_VERSION_PRIMERA_POLIZAS;
        ineDTO.indDigitalFirm = CONSTANTE_INDDIGITALFIRM;
        //Si se deja esta linea que estaba antes siempre se setea la misma version V8 de restructurado
        //ineDTO.versContrato = CONSTANTE_VERSION_PRESTAMO_REESTRUCTURACIONES; //printcode igual R
        ineDTO.versContrato = elementAux?.versionContract ? elementAux.versionContract : '';
        return ineDTO;
      } else {
        ineDTO.versPolizas = CONSTANTE_VERSION_PRIMERA_POLIZAS;
        ineDTO.indDigitalFirm = CONSTANTE_INDDIGITALFIRM;
        ineDTO.isNotary = CONSTANTE_PARAM_FIRMA_DIGITAL;
        //Si se deja esta linea que estaba antes siempre se setea la misma version V8 de restructurado
        //ineDTO.versContrato = CONSTANTE_VERSION_PRESTAMO_REESTRUCTURACIONES; // printcode igual R
        ineDTO.versContrato = elementAux?.versionContract ? elementAux.versionContract : '';
        return ineDTO;
      }
    }

    if (element.digitalSignatureFlag !== 'S') {
      ineDTO.versContrato = CONSTANTE_VERSION_SUBROGACION_LEASING;
      ineDTO.indDigitalFirm = CONSTANTE_INDDIGITALFIRM;
      return ineDTO;
    } else {
      ineDTO.versContrato = CONSTANTE_VERSION_SUBROGACION_LEASING;
      ineDTO.indDigitalFirm = CONSTANTE_INDDIGITALFIRM;
      ineDTO.isNotary = CONSTANTE_PARAM_FIRMA_DIGITAL;
      return ineDTO;
    }
  }

  public validateVideoSelfing(element: Operation, userInfo: any): any {
    let videoSelfingDTO: VideoSelfingDTO;
    videoSelfingDTO = {
      numOperation: element.numOperation,
      financialProduct: element.finacialProduct,
      dateEntry: element.dateEntry,
      operative: element.operative,
      comarca: element.comarca,
      language: element.language,
      noMobile: element.noMobile,
    };

    if (userInfo.typeUser !== 'M') {
      if (element.digitalSignatureFlag !== 'S') {
        videoSelfingDTO.policyVersion = CONSTANTE_VERSION_PRIMERA_POLIZAS;
        videoSelfingDTO.indDigitalFirm = CONSTANTE_INDDIGITALFIRM;
        videoSelfingDTO.contractVersion = CONSTANTE_VERSION_PRESTAMO_REESTRUCTURACIONES; //printcode igual R
        return videoSelfingDTO;
      } else {
        videoSelfingDTO.policyVersion = CONSTANTE_VERSION_PRIMERA_POLIZAS;
        videoSelfingDTO.indDigitalFirm = CONSTANTE_INDDIGITALFIRM;
        videoSelfingDTO.isNotary = CONSTANTE_PARAM_FIRMA_DIGITAL;
        videoSelfingDTO.contractVersion = CONSTANTE_VERSION_PRESTAMO_REESTRUCTURACIONES; // printcode igual R
        return videoSelfingDTO;
      }
    }

    if (element.digitalSignatureFlag !== 'S') {
      videoSelfingDTO.contractVersion = CONSTANTE_VERSION_SUBROGACION_LEASING;
      videoSelfingDTO.indDigitalFirm = CONSTANTE_INDDIGITALFIRM;
      return videoSelfingDTO;
    } else {
      videoSelfingDTO.contractVersion = CONSTANTE_VERSION_SUBROGACION_LEASING;
      videoSelfingDTO.indDigitalFirm = CONSTANTE_INDDIGITALFIRM;
      videoSelfingDTO.isNotary = CONSTANTE_PARAM_FIRMA_DIGITAL;
      return videoSelfingDTO;
    }
  }
}
